import { useContextFallback } from '@prenuvo/halo-foundation';

import { UserContext } from './user.context';

export const useUser = () => useContextFallback(UserContext);
